var GiftMessageView = (function (_baseView) {
    return _baseView.extend({
        el: '@currentGiftMessage',

        events: {
            'click': '_open'
        },

        initialize: function () {
            _.bindAll(this, '_toggle', '_open');

            this.listenTo(this.model.currentGiftMessage(), 'change', this._toggle);
            this.listenTo(this.model.deliveryModeSwitcher(), 'change', this._toggle);
        },

        _toggle: function (m) {
            var _deliveryModeSwitcher = this.model.deliveryModeSwitcher();
            var currentMode = _deliveryModeSwitcher.getMode();
            var giftMessage = this.model.currentGiftMessage();

            var message = giftMessage.getMessage();
            var occasion = giftMessage.get('GiftOccasion');
            var date = giftMessage.get('GiftDate');

            var displayMessage = !!message && currentMode === 1;
            var displayOccasion = !!occasion && currentMode === 1;
            var displayDate = !!date && currentMode === 1;

            if (displayMessage) {
                this.$('@message').html('"' + giftMessage.getHtmlMessage() + '"');
            }
            this.$('@message').toggleClass('hidden-block', !displayMessage);
            this.$('@messageTitle').toggleClass('hidden-block', !displayMessage);

            if (displayOccasion) {
                this.$('@occasion').text(occasion);
            }
            this.$('@occasion').toggleClass('hidden-block', !displayOccasion);
            this.$('@occasionTitle').toggleClass('hidden-block', !displayOccasion);

            if (displayDate) {
                this.$('@date').text(date.format('dd mmmm yyyy'));
            }
            this.$('@date').toggleClass('hidden-block', !displayDate);
            this.$('@dateTitle').toggleClass('hidden-block', !displayDate);

            this.$el.toggleClass('hidden-block', !displayMessage && !displayOccasion && ! displayDate);
        },

        _open: function () {
            this.display('checkout.address.gift.message.form');
        }
    });
})(BaseView);